import { PaymentMethod } from "@/model/enum/PaymentMethod";
export function createOrderPayment() {
    return {
        date: new Date(),
        paymentMethod: PaymentMethod.BANK_TRANSFER,
        amount: 0
    };
}
export function initOrderPayment(target, source) {
    Object.assign(target, source);
    target.date = new Date(source.date);
    return target;
}
